const DEFAULT_SUPPLIER_DIRECTORY_URL = "/supplier-directory/";
const SUPPLIER_DIRECTORY_RESULTS_ANCHOR = "chamfr-supplier-directory-results";

export const getSupplierDirectoryUrl = (supplierDirectoryUrl = "") =>
  typeof supplierDirectoryUrl === "string" && supplierDirectoryUrl
    ? supplierDirectoryUrl
    : DEFAULT_SUPPLIER_DIRECTORY_URL;

export const getSupplierUrl = (supplier, supplierDirectoryUrl = "") => {
  const directoryUrl = getSupplierDirectoryUrl(supplierDirectoryUrl);

  if (supplier?.shop_address) {
    return supplier.shop_address;
  }

  if (supplier?.key) {
    return `${directoryUrl}#${encodeURIComponent(supplier.key)}`;
  }

  return directoryUrl;
};

export const getSupplierDirectoryQueryUrl = (query, supplierDirectoryUrl = "") => {
  const directoryUrl = getSupplierDirectoryUrl(supplierDirectoryUrl);
  const separator = directoryUrl.includes("?") ? "&" : "?";

  return `${directoryUrl}${separator}[query]=${encodeURIComponent(query)}#${SUPPLIER_DIRECTORY_RESULTS_ANCHOR}`;
};
